// extracted by mini-css-extract-plugin
export var fadeInAnimation = "VideoPlayer-module--fade-in-animation--f8094";
export var loaded = "VideoPlayer-module--loaded--8c569";
export var videoPlayer = "VideoPlayer-module--videoPlayer--09d93";